import Vue from "vue";
import Router from "vue-router";

import list from "@/components/list/list";

import childPath from "@/components/";
import home from "@/components/home";
import login from "@/components/login/login";
import auth from "@/components/login/auth";
import doc from "@/components/doc/doc";
import locate from "@/components/locate/";
import apply from "@/components/apply/apply";
import addApply from "@/components/apply/addApply";
import approval from "@/components/approval/approval";
import dispatch from "@/components/dispatch/dispatch";

import lichengfenxi from "@/components/fenxi/licheng";
import baojingfenxi from "@/components/fenxi/baojing";
import feiyongfenxi from "@/components/fenxi/feiyong";

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      component: login
    },
    {
      path: "/auth",
      component: auth
    },
    {
      path: "/childPath",
      component: childPath,
      meta: { auth: true },
      children: [
        {
          path: "/home",
          component: home
        },
        {
          path: "/list",
          component: list
        },
        {
          path: "/doc",
          component: doc
        },
        {
          path: "/locate",
          component: locate
        },
        {
          path: "/scheduling/apply",
          component: apply
        },
        {
          path: "/scheduling/addApply",
          component: addApply
        }
        ,
        {
          path: "/scheduling/approval",
          component: approval
        },
        {
          path: "/scheduling/dispatch",
          component: dispatch
        },
        {
          path: "/fenxi/feiyong",
          component: feiyongfenxi
        },
        {
          path: "/fenxi/licheng",
          component: lichengfenxi
        },
        {
          path: "/fenxi/baojing",
          component: baojingfenxi
        }
      ]
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    // 对路由进行验证
    var mydata = localStorage.getItem('phone');
    if (mydata == null || mydata == '') { // 已经登陆       
      next({ path: '/login' })
    }
    else {
      next()   // 正常跳转到你设置好的页面  
    }
  } else {
    next()
  }

})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js